export default __webpack_public_path__ + "static/media/c8.895a0847.jpg";